BatchGeoStore.addReducer("HeatMap", function (state, action) {
  state = state || {
    initialized: false,
    enabled: null,
  };

  switch (action.type) {
    case "HEATMAP_INITIALIZE":
      return _.merge({}, state, { initialized: true });

    case "HEATMAP_ENABLE":
      return _.merge({}, state, { enabled: true });

    case "HEATMAP_DISABLE":
      return _.merge({}, state, { enabled: false });

    case "HEATMAP_SET_ENABLED":
      return _.merge({}, state, { enabled: !!action.enabled });

    case "HEATMAP_TOGGLE":
      return _.merge({}, state, { enabled: !state.enabled });

    default:
      return state;
  }
});
